module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.vodeOption) ? _c('div', {
    staticClass: "ballot"
  }, [_c('div', {
    staticClass: "ballot-title"
  }, [_c('p', [_vm._v(_vm._s(_vm.vodeOption.title))])]), _vm._v(" "), (_vm.isResult) ? _c('div', {
    staticClass: "ballot-result"
  }, [(_vm.vodeOption.options.length > 0) ? _c('i') : _vm._e(), _vm._v(" "), _vm._l((_vm.vodeOption.options), function(item) {
    return _c('div', {
      key: item.id,
      class: _vm.voteSelectedList.indexOf(item.id + '') >= 0 ?
        (item.imageUrl ? 'item item-checked imageUrl' : _vm.isSharePage ? 'item noimageUrl' : 'item item-checked noimageUrl') :
        (item.imageUrl ? 'item  imageUrl' : _vm.isSharePage ? 'item  noimageUrl' : 'item  noimageUrl'),
      style: (_vm.voteSelectedList.indexOf(item.id + '') >= 0 ?
        'background:linear-gradient(to right, rgba(237,244,254,1)' + item.percentage + '%, rgba(255,255,255,1)' + item.percentage + '%' :
        'background:linear-gradient(to right, rgba(249,249,249,1)' + item.percentage + '%, rgba(255,255,255,1)' + item.percentage + '%')
    }, [(item.imageUrl) ? _c('div', {
      staticClass: "itemImg"
    }, [_c('img', {
      attrs: {
        "src": item.imageUrl
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-title"
    }, [_c('span', {
      staticStyle: {
        "-webkit-box-orient": "vertical",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (_vm.voteSelectedList.indexOf(item.id + '') >= 0) ? _c('img', {
      staticClass: "votechecked-img",
      attrs: {
        "src": _vm.voteChecked
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-percentage"
    }, [_vm._v(_vm._s(item.percentage || '0.0') + "%")])])
  })], 2) : _c('div', {
    staticClass: "ballot-list",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.vodeOption.type == 'radio') ? _c('div', [(_vm.vodeOption.options.length > 0) ? _c('i') : _vm._e(), _vm._v(" "), _vm._l((_vm.vodeOption.options), function(item) {
    return _c('div', {
      key: item.id,
      class: item.imageUrl ? 'item imageUrl' : 'item noimageUrl',
      on: {
        "click": function($event) {
          return _vm.addVote(item, 'radio')
        }
      }
    }, [(item.imageUrl) ? _c('div', {
      staticClass: "itemImg"
    }, [_c('img', {
      attrs: {
        "src": item.imageUrl
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-title"
    }, [_c('span', {
      staticStyle: {
        "-webkit-box-orient": "vertical"
      }
    }, [_vm._v(_vm._s(item.title))])])])
  })], 2) : (_vm.vodeOption.type == 'checkbox') ? _c('div', [(_vm.vodeOption.options.length > 0) ? _c('i', {
    staticStyle: {
      "padding": "0 4px",
      "left": "-6px"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.vodeOption.options), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "checkbox-box",
      on: {
        "click": function($event) {
          return _vm.handleItemClick(item.id)
        }
      }
    }, [_c('div', {
      class: item.imageUrl ? 'checkbox-item item imageUrl' : 'checkbox-item item noimageUrl',
      staticStyle: {
        "padding": "0.333333rem 0"
      }
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('span', {
      class: _vm.voteSelectedList.indexOf(item.id + '') >= 0 ? 'checked' : ''
    })]), _vm._v(" "), (item.imageUrl) ? _c('div', {
      staticClass: "itemImg"
    }, [_c('img', {
      attrs: {
        "src": item.imageUrl
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-title"
    }, [_c('span', {
      staticStyle: {
        "-webkit-box-orient": "vertical"
      }
    }, [_vm._v(_vm._s(item.title))])])])])
  }), _vm._v(" "), (!_vm.isSharePage) ? _c('div', {
    staticClass: "btn-ok",
    on: {
      "click": function($event) {
        return _vm.addVote([], 'checkbox')
      }
    }
  }, [_vm._v("投票")]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('dialogComponent', {
    attrs: {
      "params": _vm.dialogParams,
      "is-show": _vm.isShowDialog
    },
    on: {
      "on-close": _vm.closeDialog,
      "on-ok": _vm.okDialog
    }
  }, [_c('div', {
    staticClass: "dialog_publish_main",
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_vm._v("\n\t\t\t\t即将离开当前页面"), _c('br'), _vm._v("打开“成都日报锦观”客户端\n\t\t\t")])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33ee5711!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-vote.vue
// module id = 843
// module chunks = 2